import { ButtonBase, Skeleton, Stack, Typography } from '@razz-team/ui-web';
import { AppLogo } from '../Logo/AppLogo';

export function ProfileButton({
  businessName,
  customerName,
}: {
  businessName: string | undefined;
  customerName: string | undefined;
}) {
  return (
    <ButtonBase href="/account/home">
      <Stack direction="row" spacing={2} alignItems="center">
        <AppLogo size={40} type="compact" />
        <Stack direction="column" spacing={0.5}>
          <Typography variant="h6">{businessName ?? <Skeleton variant="text" />}</Typography>
          <Typography variant="body1">{customerName ?? <Skeleton variant="text" />}</Typography>
        </Stack>
      </Stack>
    </ButtonBase>
  );
}
